import type { CSSProperties } from "react";
import { resolveTootPrimitive } from "../../../../client";
import { TootActions } from "../../../layout/components/TootActions/TootActions";
import { TootHeading } from "../../../layout/components/TootHeading/TootHeading";
import { TootSectionShell } from "../../../layout/components/TootSectionShell/TootSectionShell";
import type { ITootHeroBackgroundImageProps } from "./TootHeroBackgroundImage.props";

export const TootHeroBackgroundImage = ({
  alignment,
  anchorId,
  buttons,
  eyebrow,
  heading,
  image,
  parentClass,
  priority,
  spacing,
  subheading,
}: ITootHeroBackgroundImageProps) => {
  const Image = resolveTootPrimitive("Image");
  const headingAlignment = alignment === "center" ? "center" : "left";
  const imageStyle: CSSProperties | undefined = image?.focalPoint
    ? {
        objectPosition: `${image.focalPoint.x * 100}% ${image.focalPoint.y * 100}%`,
      }
    : undefined;

  return (
    <TootSectionShell
      className="relative isolate grid h-screen max-h-[65rem] items-center overflow-hidden"
      id={anchorId ?? undefined}
      rootClassName={parentClass}
      spacing={undefined}
      tone="default"
      width="full"
    >
      {image ? (
        <Image
          alt={image.alternateText}
          className="toot-hero-background-image h-full w-full object-cover"
          height={image.height ?? undefined}
          loading={priority ? "eager" : "lazy"}
          sizes={image.sizes ?? "100vw"}
          src={image.defaultSrc}
          srcSet={image.srcSet ?? undefined}
          style={imageStyle}
          width={image.width ?? undefined}
        />
      ) : null}
      <div aria-hidden="true" className="toot-hero-background-vignette opacity-50" />
      <div className="toot-hero-background-inner">
        <div className="min-w-0">
          <div className="toot-hero-background-copy relative z-10 flex flex-col gap-8">
            <TootHeading
              actions={
                buttons?.length ? (
                  <TootActions actions={buttons} alignment={headingAlignment} />
                ) : null
              }
              alignment={headingAlignment}
              as="h1"
              eyebrow={eyebrow}
              heading={heading}
              inverse
              size="hero"
              subheading={subheading}
            />
          </div>
        </div>
      </div>
    </TootSectionShell>
  );
};

TootHeroBackgroundImage.displayName = "Content::TootHeroBackgroundImage";
